import {
	Alert,
	AppBar,
	Avatar,
	Badge,
	Box,
	CircularProgress,
	Container,
	createSvgIcon,
	CssBaseline,
	Divider,
	Icon,
	IconButton,
	Link,
	ListItemIcon,
	ListItemText,
	Menu,
	MenuItem,
	Paper,
	Snackbar,
	Stack,
	Toolbar,
	Tooltip,
	Typography,
	useMediaQuery,
	useTheme,
} from "@mui/material";
import { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { ReactComponent as EasyFlow } from "../../assets/icons/IconEasyFlow.svg";
import api from "../../services/api";

import useStyles from "./styles";

import {
	AssignmentOutlined,
	AttachMoneyOutlined,
	BarChart,
	CableOutlined,
	DarkModeOutlined,
	Dashboard,
	HomeOutlined,
	InsertChartOutlined,
	LightModeOutlined,
	ListAltOutlined,
	LocalOfferOutlined,
	LockReset,
	LogoutOutlined,
	ManageAccountsOutlined,
	MenuOutlined,
	MonitorHeart,
	OpenInNewOutlined,
	PermIdentityOutlined,
	PersonOutline,
	Phonelink,
	ReceiptOutlined,
	RequestQuoteOutlined,
	RouterOutlined,
	SettingsOutlined,
	ShareOutlined,
	SupervisorAccountOutlined,
	SupportAgentOutlined,
	TextSnippetOutlined,
	SyncOutlined,
	UpdateOutlined,
	VpnKeyOutlined,
} from "@mui/icons-material";
import dayjs from "dayjs";
import CircularProgressWithLabel from "../../components/circularProgressWithLabel";
import ModalEditSenhaUserLogado from "../../components/internoModalEditSenha";
import ModalPerfil from "../../components/internoModalPerfil";
import SideBar from "../../components/sideBar";

const EasyFlowIcon = createSvgIcon(<EasyFlow />);
// import { createSvgIcon } from "@mui/material/utils";

const OpticalTransceiverIcon = createSvgIcon(
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		{/* Corpo do módulo */}
		<rect
			x="4"
			y="7"
			width="14"
			height="10"
			rx="2"
			ry="2"
			fill="none"
			stroke="currentColor"
			strokeWidth="1.5"
		/>

		{/* Porta de conexão (frente do transceptor) */}
		<rect
			x="18"
			y="10"
			width="3"
			height="4"
			fill="none"
			stroke="currentColor"
			strokeWidth="1.5"
		/>

		{/* Detalhes internos (contatos) */}
		<line x1="6" y1="9" x2="14" y2="9" stroke="currentColor" strokeWidth="1" />
		<line
			x1="6"
			y1="15"
			x2="14"
			y2="15"
			stroke="currentColor"
			strokeWidth="1"
		/>
	</svg>,
	"OpticalTransceiver",
);
function Layout(params) {
	const perfil = JSON.parse(localStorage.getItem("perfil"));
	const { colorMode, setColorMode, contratoVencimento, setContratoVencimento } =
		params;
	const [anchorEl, setAnchorEl] = useState(null);
	const [baseImage, setBaseImage] = useState(
		JSON.parse(localStorage.getItem("perfil"))?.foto || "",
	);

	const [administrador, setAdministrador] = useState(false);
	const [openModalPerfil, setOpenModalPerfil] = useState(false);
	const [openModalEditSenha, setOpenModalEditSenha] = useState(false);
	const [snackbar, setSnackbar] = useState(null);
	const [windowWith, setWindowWith] = useState(window.innerWidth);

	const [clientes, setClientes] = useState([]);
	const [notificacoes, setNotificacoes] = useState([]);
	const [anchorNotificacao, setAnchorNotificacao] = useState(null);
	const openNotificacao = Boolean(anchorNotificacao);
	// Indicador discreto do item Versionamento: coleta falhando ou cliente desatualizado, por aba
	const [alertaVersionamento, setAlertaVersionamento] = useState({
		temAlerta: false,
		template: false,
		script: false,
	});
	const theme = useTheme();
	const styles = useStyles(theme);
	const erp = window?.config?.REACT_APP_ERP || process.env.REACT_APP_ERP;
	const navigate = useNavigate();
	//funcoes de controle do menu
	const open = Boolean(anchorEl);

	//CONTROLLER PARA ABORT ######################################3
	const [controllerDashboard, setControllerDashboard] = useState(null);

	const [loadingCronometro, setLoadingCronometro] = useState(false);
	//################################################3

	//TEMPO SELECIONADO E FILTRO ################################################
	const [selectTime, setSelectTime] = useState(2);
	const [filterData, setFilterData] = useState({
		clienteId: "",
		interfaceId: "",
		hostId: "",
		initialDate: dayjs()
			.subtract(30, "minute")
			.set("second", 0)
			.set("millisecond", 0)
			.toDate(),
		finalDate: dayjs().set("second", 0).set("millisecond", 0).toDate(),
	});

	//################################################################

	//################################################

	//CONTADOR DE CRONOMETRO E VERIFICADOR DE FILTRO
	const [isFilter, setIsFilter] = useState(false);
	const [counter, setCounter] = useState(null);
	//#################################################33

	// drawer ##########################
	const [titlePage, setTitlePage] = useState("");
	const [openSideBar, setOpenSideBar] = useState(true);
	const [openDrawer, setOpenDrawer] = useState(false);
	const isScreenSmall = useMediaQuery(theme.breakpoints.up("lg"));
	const [openFilter, setOpenFilter] = useState(false);

	const logoDark = `${
		window?.config?.REACT_APP_LOGO_EXTERNO_DARK ||
		process.env.REACT_APP_LOGO_EXTERNO_DARK ||
		""
	}`;
	//#######################################################

	useEffect(() => {
		let sidebarOpen = JSON.parse(localStorage.getItem("sidebarCollapsed"));

		if (sidebarOpen !== null) setOpenSideBar(sidebarOpen);
	}, []);

	useEffect(() => {
		if (isScreenSmall) {
			setOpenDrawer(false);
		}
	}, [isScreenSmall]);

	// Chamada de api ao carregar a página
	useEffect(() => {
		handleUsuarioId();

		const pagesDash = [
			"/dash/overview",
			"/dash/saude",
			"/dash/disponibilidade",
			"/dash/flow",
		];

		setIsFilter(
			pagesDash?.find((page) => window.location.pathname.includes(page))
				? true
				: false,
		);
	}, [window.location.pathname]);

	// Define imagem de perfil
	useEffect(() => {
		setBaseImage(
			localStorage.getItem("perfil") &&
				JSON.parse(localStorage.getItem("perfil")) != "undefined"
				? JSON.parse(localStorage.getItem("perfil"))?.foto
				: "",
		);
	}, [localStorage.getItem("perfil")]);

	useEffect(() => {
		const handleResize = () => {
			setWindowWith(window.innerWidth);
		};
		handleApiGetClientes();

		window.addEventListener("resize", handleResize);
	}, []);

	// Verifica uma vez, ao montar, se ha coleta falhando ou cliente desatualizado em Versionamento
	// Usa o endpoint leve /alerta (so o booleano) em vez do endpoint completo, que decifraria credencial de todo cliente a toa
	useEffect(() => {
		async function verificarAlertaVersionamento() {
			try {
				const response = await api.get("/versionamento/templates/alerta");
				setAlertaVersionamento({
					temAlerta: Boolean(response?.data?.temAlerta),
					template: Boolean(response?.data?.template),
					script: Boolean(response?.data?.script),
				});
			} catch (error) {
				// Falha silenciosa - usuario pode nao ter nenhum cliente Zabbix cadastrado ainda
			}
		}
		verificarAlertaVersionamento();
	}, []);

	useEffect(() => {
		const notificacoesContrato = clientes?.filter(
			(cliente) =>
				cliente?.contrato?.length > 1 || cliente?.contrato?.length === 0,
		);
		const notificacoesBlocosFlowDelete = clientes?.filter(
			(cliente) => cliente?.blocoFlowDelete?.length >= 1,
		);

		const notificacoesBlocosFlow = notificacoesBlocosFlowDelete?.map(
			(notificacoesBlocosFlow) => {
				return {
					nomeFantasia: notificacoesBlocosFlow?.nomeFantasia,
					message: `Bloco não localizado no Juniper`,
					link: `/home/perfil/easyflow/${notificacoesBlocosFlow?.id}`,
					icon: <EasyFlowIcon fontSize="small" sx={{ marginRight: "10px" }} />,
				};
			},
		);

		const notificacoes = notificacoesContrato?.map((notificacaoContrato) => {
			if (notificacaoContrato?.contrato?.length > 1) {
				return {
					nomeFantasia: notificacaoContrato?.nomeFantasia,
					message: `Existem ${notificacaoContrato?.contrato?.length} contratos ativos`,
					link: `/home/perfil/financeiro/${notificacaoContrato?.id}`,
					icon: (
						<AttachMoneyOutlined
							fontSize="small"
							sx={{ marginRight: "10px" }}
						/>
					),
				};
			} else {
				return {
					nomeFantasia: notificacaoContrato?.nomeFantasia,
					message: `Cliente não possui contrato ativo`,
					link: `/home/perfil/financeiro/${notificacaoContrato?.id}`,
					icon: (
						<AttachMoneyOutlined
							fontSize="small"
							sx={{ marginRight: "10px" }}
						/>
					),
				};
			}
		});
		setNotificacoes([...notificacoes, ...notificacoesBlocosFlow]);
	}, [clientes]);

	useEffect(() => {
		if (
			filterData?.finalDate &&
			filterData?.initialDate &&
			filterData?.interfaceId &&
			filterData?.hostId &&
			filterData?.clienteId
		) {
			const dataFilterStorage = {
				interfaceId: filterData?.interfaceId,
				clienteId: filterData?.clienteId,
				hostId: filterData?.hostId,
				selectTime: selectTime,
				initialDate: filterData?.initialDate,
				finalDate: filterData?.finalDate,
			};

			localStorage.setItem("filterData", JSON.stringify(dataFilterStorage));
		}
	}, [filterData]);

	// Verifica se o usuário é um administrador
	const handleUsuarioId = () => {
		let result = localStorage.getItem("user");
		result = JSON.parse(result);
		// Verifica se a propriedade rlPermissoesUsuario existe e é um array
		if (Array.isArray(result?.usuario?.rlPermissoesUsuario)) {
			// Itera sobre o array para verificar se algum objeto contém a propriedade codigoPermissao com valor "ADM"
			for (let permissao of result?.usuario?.rlPermissoesUsuario) {
				if (permissao?.permissao?.codigoPermissao.toUpperCase() === "ADM") {
					setAdministrador(true);
				}
			}
			return false;
		}

		if (result) {
			setBaseImage(result.foto);
		} else {
			return "";
		}
	};

	async function handleApiGetClientes() {
		try {
			const response = await api.get("/getClients");

			setClientes(response?.data?.filter((cliente) => cliente?.status === 0));
		} catch (error) {
			setSnackbar({
				children: "Error: Não foi possivel se conectar ao servidor",
				severity: "error",
			});
		} finally {
		}
	}

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
		setAnchorNotificacao(null);
	};

	const handleLogout = () => {
		localStorage.clear();
		navigate("/login");
	};

	const handleCloseModalPerfil = () => {
		setOpenModalPerfil(false);
	};

	const handleDrawerToggle = () => {
		setOpenDrawer((preValue) => !preValue);
	};

	// Texto do tooltip do dot de Versionamento, dizendo qual aba precisa de atencao
	const abasComAlerta = [
		alertaVersionamento.template && "Templates",
		alertaVersionamento.script && "Scripts",
	].filter(Boolean);
	const tooltipAlertaVersionamento =
		abasComAlerta.length > 0
			? `${abasComAlerta.join(" e ")} desatualizados`
			: "";

	const sideBarPages = [
		{
			itemId: "1",
			label: "Home",
			hideTitle: true,
			link: "/resumo",
			icon: <HomeOutlined />,
		},
		{
			itemId: "2",
			label: "Clientes",
			hideTitle: true,
			link: "/home/perfil",
			icon: <PermIdentityOutlined />,
		},

		{
			itemId: "5",
			label: "Versionamento",
			hideTitle: true,
			link: "/versionamento",
			icon: (
				<Tooltip title={tooltipAlertaVersionamento} placement="right">
					<Badge
						variant="dot"
						color="error"
						invisible={!alertaVersionamento.temAlerta}
					>
						<UpdateOutlined />
					</Badge>
				</Tooltip>
			),
		},

		{
			itemId: "3",
			label: "Templates",
			hideTitle: true,
			link: "/templates",
			icon: <RouterOutlined />,
		},

		...(administrador
			? [
					{
						itemId: "4",
						label: "Administração",
						hideTitle: true,
						link: "/administracao",
						icon: <SupervisorAccountOutlined />,
						nodes: [
							{
								itemId: "4.1",
								label: "Usuários",
								hideTitle: true,
								link: "/administracao/usuarios",
								icon: <PermIdentityOutlined />,
							},

							{
								itemId: "4.2",
								label: "Auditoria",
								hideTitle: true,
								link: "/administracao/auditoria",
								icon: <AssignmentOutlined />,
							},
							{
								itemId: "4.3",
								label: "Integração ERP",
								hideTitle: true,
								link: "/administracao/integracaoErp",
								icon: <SyncOutlined />,
							},
							{
								itemId: "4.4",
								label: "Licenças",
								hideTitle: true,
								link: "/administracao/licencas",
								icon: <VpnKeyOutlined />,
							},
						],
					},
				]
			: []),
	];

	return (
		<Box display={"flex"}>
			<CssBaseline />
			{windowWith < 1350 && (
				<AppBar
					sx={{
						background: theme.palette.gradient.sidebar,
					}}
					position="fixed"
					elevation={0}
				>
					<Container maxWidth="100vw">
						<Toolbar sx={styles.toolbar}>
							<Box sx={styles.toolbarNavigate}>
								<IconButton
									sx={{
										padding: "0px",
										transform: "translateX(-20px)",
										color: theme.palette.white.main,
									}}
									onClick={() => {
										handleDrawerToggle();
									}}
								>
									<MenuOutlined fontSize="medium" />
								</IconButton>

								<IconButton href={"/resumo"} sx={styles.IconButtonLogo}>
									<Icon style={styles.logo}>
										<img src={logoDark} style={styles.logo} alt="logo-home" />
									</Icon>
								</IconButton>
							</Box>
							<Box
								sx={{
									display: "flex",
									flexDirection: "row",
									gap: 3,
									alignItems: "center",
								}}
							>
								{loadingCronometro &&
								(selectTime || selectTime === 0) &&
								isFilter ? (
									<CircularProgress sx={{ color: "primary" }} />
								) : (counter || counter === 0) &&
								  (selectTime || selectTime === 0) &&
								  isFilter ? (
									<CircularProgressWithLabel value={counter} />
								) : (
									<></>
								)}

								<Menu
									open={openNotificacao}
									anchorEl={anchorNotificacao}
									placement={"bottom-end"}
									onClose={handleClose}
								>
									<Divider />
									<Box sx={styles.containerMenuNotificacoes}>
										{Array.isArray(notificacoes) &&
											notificacoes?.map((pendente, index) => (
												<Box>
													<Link
														sx={styles.linkNotificacao}
														underline="hover"
														href={pendente?.link}
													>
														<MenuItem
															sx={styles.menuItem}
															key={`${pendente?.id}-${index}`}
														>
															{pendente?.icon}

															<Box sx={styles.containerNotificacoes}>
																<Typography
																	sx={styles.textClientNotificacoes}
																	variant="caption"
																>
																	{pendente?.nomeFantasia}
																</Typography>
																<Typography variant="caption">
																	{pendente?.message}
																</Typography>
															</Box>
															<OpenInNewOutlined
																sx={styles.iconLink}
																fontSize="small"
															/>
														</MenuItem>
													</Link>
													<Divider />
												</Box>
											))}
									</Box>
								</Menu>
							</Box>
						</Toolbar>
					</Container>
				</AppBar>
			)}
			<Box sx={{ width: "100%" }}>
				{windowWith < 1350 && <Box sx={{ height: "60px", width: "50vw" }} />}

				<Stack direction={"row"}>
					<SideBar
						defaultExpandedItems={["4"]}
						items={sideBarPages}
						title=""
						titlePage={titlePage}
						setTitlePage={setTitlePage}
						openSideBar={openSideBar}
						setOpenSideBar={setOpenSideBar}
						openDrawer={openDrawer}
						setOpenDrawer={setOpenDrawer}
						Perfil={
							<Box sx={styles.boxAvatar}>
								<Tooltip title="Abrir Opções">
									{openSideBar || openDrawer ? (
										<Paper
											variant={"outlined"}
											sx={styles.paperAvatar}
											id="basic-button"
											onClick={handleClick}
										>
											<Avatar
												src={baseImage}
												sx={{
													color: theme.palette.white.main,
													bgcolor: theme.palette.secondary.dark,
												}}
											/>
											<Typography noWrap sx={styles.titleAvatar}>
												{perfil?.nome
													? `${perfil?.nome} ${perfil?.sobrenome}`
													: ""}
											</Typography>
										</Paper>
									) : (
										<IconButton onClick={handleClick}>
											<Avatar
												src={baseImage}
												sx={{
													color: theme.palette.white.main,
													bgcolor: theme.palette.secondary.dark,
												}}
											/>
										</IconButton>
									)}
								</Tooltip>

								<Menu
									open={openNotificacao}
									anchorEl={anchorNotificacao}
									placement={"bottom-end"}
									onClose={handleClose}
								>
									<Divider />
									<Box sx={styles.containerMenuNotificacoes}>
										{Array.isArray(notificacoes) &&
											notificacoes?.map((pendente, index) => (
												<Box>
													<Link
														sx={styles.linkNotificacao}
														underline="hover"
														href={pendente?.link}
													>
														<MenuItem
															sx={styles.menuItem}
															key={`${pendente?.id}-${index}`}
														>
															{pendente?.icon}

															<Box sx={styles.containerNotificacoes}>
																<Typography
																	sx={styles.textClientNotificacoes}
																	variant="caption"
																>
																	{pendente?.nomeFantasia}
																</Typography>
																<Typography variant="caption">
																	{pendente?.message}
																</Typography>
															</Box>
															<OpenInNewOutlined
																sx={styles.iconLink}
																fontSize="small"
															/>
														</MenuItem>
													</Link>
													<Divider />
												</Box>
											))}
									</Box>
								</Menu>
							</Box>
						}
					/>

					<Box sx={styles.containerFilter}>
						<Box component="main" sx={styles.main}>
							<Box>
								<Outlet
									context={{
										controllerDashboard,
										setControllerDashboard,
										api,
									}}
								/>
							</Box>
						</Box>
					</Box>
				</Stack>
			</Box>

			{/* Menu de Opções */}
			<Menu
				id="basic-menu"
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				MenuListProps={{
					"aria-labelledby": "basic-button",
				}}
				disableScrollLock={true}
				anchorOrigin={{
					vertical: "top",
					horizontal: "center",
				}}
				transformOrigin={{
					vertical: "bottom",
					horizontal: "center",
				}}
				sx={{
					"& .MuiPaper-root": {
						borderRadius: "10px",
						width: "200px",
						bgcolor: theme.palette.secondary.darker,
						color: theme.palette.white.main,
					},
				}}
			>
				<MenuItem //</Menu>onClick={handlePerfil}
					onClick={() => {
						setOpenModalPerfil(true);
						setAnchorEl(null);
					}}
				>
					<ListItemIcon>
						<PersonOutline sx={{ color: theme.palette.white.main }} />
					</ListItemIcon>
					<ListItemText>Perfil</ListItemText>
				</MenuItem>
				<MenuItem
					onClick={() => {
						setOpenModalEditSenha(true);
						setAnchorEl(null);
					}}
				>
					<ListItemIcon>
						<LockReset sx={{ color: theme.palette.white.main }} />
					</ListItemIcon>
					<ListItemText>Alterar Senha</ListItemText>
				</MenuItem>
				<MenuItem
					onClick={() =>
						setColorMode((prev) => {
							localStorage.setItem("darkMode", !prev);
							return !prev;
						})
					}
				>
					{colorMode ? (
						<>
							<ListItemIcon>
								<DarkModeOutlined sx={{ color: theme.palette.white.main }} />
							</ListItemIcon>
							<ListItemText>Modo Noturno</ListItemText>
						</>
					) : (
						<>
							<ListItemIcon>
								<LightModeOutlined sx={{ color: theme.palette.white.main }} />
							</ListItemIcon>
							<ListItemText>Modo Claro</ListItemText>
						</>
					)}
				</MenuItem>

				<MenuItem onClick={handleLogout}>
					<ListItemIcon>
						<LogoutOutlined sx={{ color: theme.palette.white.main }} />
					</ListItemIcon>
					<ListItemText>Sair</ListItemText>
				</MenuItem>
			</Menu>
			<ModalPerfil
				open={openModalPerfil}
				handleClose={handleCloseModalPerfil}
			/>
			<ModalEditSenhaUserLogado
				open={openModalEditSenha}
				handleClose={() => {
					setOpenModalEditSenha(false);
				}}
				setSnackbar={setSnackbar}
			/>
			{!!snackbar && (
				<Snackbar
					open
					onClose={() => setSnackbar(null)}
					autoHideDuration={2500}
					anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
				>
					<Alert {...snackbar} onClose={() => setSnackbar(null)} />
				</Snackbar>
			)}
		</Box>
	);
}

export default Layout;
